import { NewTable } from '@vallourec-ui/vallourec-ui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[24]};
  width: 100%;
  background: ${({ theme }) => theme.colors['neutral-color-5']};
`

export const StyledTable = styled(NewTable.Root)`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    vertical-align: top;
    text-align: left;
    padding: ${({ theme }) => theme.spacing[8]};
  }
`
export const TopAlignedCell = styled.td`
  vertical-align: top;
  text-align: left;
`
